module.exports = __webpack_public_path__ + "static/media/developerActivity.59389695.svg";